import React from 'react';
import classNames from 'classnames';

import './IntroSection.scss';

export const IntroSection = ({gap, gird, children, image, imageMobile, loading = false, backShadow = false, backButton = false }:
                             {
                               children: React.ReactNode;
                               gap?: string;
                               gird: string,
                               image?: string,
                               imageMobile?: string
                               loading?: boolean;
                               backButton?: boolean;
                               backShadow?: boolean;
                             }) => {

  return (
    <>
      <header styleName={classNames('intro-section',
        { 'intro-section--back-button': backButton,
          'intro-section--back-shadow': backShadow})}>
        {!loading && image &&
          <div styleName="intro-section__image-container">
            <div styleName="intro-section__image-clipping">
              <img styleName="intro-section__image-clipping__img" src={image} alt="" fetchPriority="high" />
            </div>
            <div styleName="intro-section__image-clipping--mobi">
              <img styleName="intro-section__image-clipping--mobi__img" src={imageMobile} alt="" fetchPriority="high" />
            </div>
            <svg styleName="intro-section__image-shadow" viewBox="0 0 1280 519" fill="none" xmlns="http://www.w3.org/2000/svg">
              <g filter="url(#filter0_d_16436_450912)">
                <path d="M1622.87 5.70016C1603.83 240.479 1162.22 396.24 636.517 353.603C110.812 310.967 -299.921 86.077 -280.879 -148.702C-261.838 -383.48 179.767 -539.242 705.473 -496.605C1231.18 -453.968 1641.91 -229.078 1622.87 5.70016Z" fill="#2E318D" />
              </g>
              <defs>
                <filter id="filter0_d_16436_450912" x="-385.516" y="-553.633" width="2113.02" height="1072.26" filterUnits="userSpaceOnUse"
                        colorInterpolationFilters="sRGB">
                  <feFlood floodOpacity="0" result="BackgroundImageFix" />
                  <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                  <feOffset dy="54" />
                  <feGaussianBlur stdDeviation="52" />
                  <feComposite in2="hardAlpha" operator="out" />
                  <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0.419608 0 0 0 0 1 0 0 0 0.3 0" />
                  <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_16436_450912" />
                  <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_16436_450912" result="shape" />
                </filter>
              </defs>
            </svg>
          </div>
        }
        <div styleName="intro-section__container" data-grid="container-fluid">
          <div data-grid="row" data-grid-justify="center">
            <div styleName="intro-section__inner" data-grid="item" data-grid-size={gird} data-grid-gap={gap}>
              {children}
            </div>
          </div>
        </div>
      </header>

      <div styleName="intro-section__bottom">
        <svg styleName="intro-section__bottom--mobile" viewBox="0.097 0.137 768 48.1" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M 0.097 0.137 C 68.046 19.101 165.945 32.341 264.763 41.297 C 389.431 52.596 534.742 49.413 662.57 36.704 C 697.873 33.195 733.701 29.106 768.097 24.378 L 768.097 0.137 L 0.097 0.137 Z"
            fill="#2E318D" />
        </svg>
        <svg styleName="intro-section__bottom--desktop" viewBox="0 0 1280 32" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M0 0.000439446C113.248 12.6169 276.413 21.4244 441.111 27.383C648.89 34.9001 891.075 32.782 1104.12 24.3275C1162.96 21.9925 1222.67 19.2721 1280 16.127V0L0 0.000439446Z"
            fill="#2E318D" />
        </svg>
      </div>
    </>
  );
};
